<div class="root-container"
     [ngClass]="{ 'disabled': disabled() }"
     [style.width.px]="width()"
     [style.width.%]="widthPercent()"
     (click)="toggle($event)"
     #container
     tabindex="1">
    <div [class]="['selection', size()]">
        @if (label()) {
            <span class="selection-label">{{ label() }}</span>
        }
        @if (selected_item) {
            <div class="selection-name" [ngClass]="{'with-label': label()}">{{ selected_item.name }}</div>
        } @else {
            <div class="selection-placeholder">{{ placeholder() }}</div>
        }
        <i class="bi bi-chevron-down"></i>
    </div>
    @if (items().length > 0) {
        <div [style.max-height.px]="height() ?? 'auto' "
             [ngClass]="{ 'open': isOpen() }"
             class="list scrollbars">
            @for (item of items(); track $index; let idx = $index) {
                <div (click)="select(item, idx, $event)" class="options">
                    <span [ngClass]="{ 'checked-label': isChecked(item.value) }">{{ item.name }}</span>
                    @if (isChecked(item.value)) {
                        <i class="bi bi-check-lg checked-icon"></i>
                    }
                </div>
            }
        </div>
    }
</div>
